<template>
    <div class="mt-12">
        <div class="border rounded-xl border-grey-200 p-10 bg-grey-100/60 prose prose-sm prose-p:my-0 prose-h3:mt-0 prose-h3:mb-0 prose-h3:text-base max-w-none" v-if="isActivated && integration.ctaType !== CtaType.NOCTA">
            <h2 class="font-medium">{{translate('aan_de_slag')}}</h2>
     
            <div v-if="intro" v-html="intro" class=" mb-12"></div>
       
            <div v-if="hasInstallStep" class="mb-10 ml-12">
                <div class="-ml-12 flex items-center">
                    <div class="size-7 inline-flex items-center justify-center mr-5 font-bold rounded-full bg-primary-100 text-primary-700 border border-primary-300">1</div>
                    <h3 class="font-medium">{{translate('download_title')}}</h3>
                </div>
                <div v-html="externalLinkText" class=""></div>
                <div v-if="externalLinkText && appText" class="my-2 ml-4 italic text-grey-700">
                    {{translate('or')}}
                </div>
                <div v-if="appText" v-html="appText" class=""></div>
            </div>

            <div v-if="apiCredentials" class="ml-12 mb-10">
                <div class="-ml-12 flex items-center">
                    <div class="size-7 inline-flex items-center justify-center mr-5 font-bold rounded-full bg-primary-100 text-primary-700 border border-primary-300">{{apiStepNumber}}</div>
                    <h3 class="font-medium">{{translate('credentials')}}</h3>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-2">
                            {{translate('credentials_text')}}
                        </div>

                        <b>{{translate('username')}}:</b> <span class="user-select-all" v-if="canSeeCredentials">{{apiCredentials.login}}</span><span v-else class="confidential">xxxxxxxxx</span><br>
                        <b>{{translate('password')}}:</b> <span class="user-select-all" v-if="canSeeCredentials">{{apiCredentials.password}}</span><span v-else class="confidential">xxxxxxxxxxx</span>
                    </div>
                </div>
                <div  v-if="!canSeeCredentials">
                    <div class="tip py-2 mt-3 d-inline-block">
                        {{translate('contact_admin_credentials')}}
                    </div>
                </div>
                <div  v-if="apiCredentials.endDate">
                    <div class="col-12">
                        <div class="tip py-2 mt-3 inline-block">
                            <template v-if="!Date.fromHansDate(apiCredentials.endDate).isInThePast()">
                                {{translate('api_enddate', Date.fromHansDate(apiCredentials.endDate).format())}}.
                            </template>
                            <template v-else>
                                {{translate('api_key_ended', Date.fromHansDate(apiCredentials.endDate).format())}}.<br>
                                <a :href="'/' + language + '/integrations/contact/' + integration.id" class="link">{{translate('contact_us')}}</a> {{translate('to_regain_access')}}
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ml-12" v-if="downloads.length > 0 || (partnerText && partnerText !== '')">
                <div class="-ml-12  flex items-center">
                    <div class="size-7 inline-flex items-center justify-center mr-5 font-bold rounded-full bg-primary-100 text-primary-700 border border-primary-300">{{downloadsStepNumber}}</div>
                    <h3 class="font-medium">{{translate('help_needed')}}</h3>
                </div>
                <div class="mt-1">
                    <div v-html="partnerText"></div>
                </div>
                <div class="grid grid-cols-6 mt-4" v-for="download in downloads" :key="download.id">
                    <div class="col-span-3">
                        <template v-if="language === 'nl'">
                            {{download.nameNl}}
                        </template>
                        <template v-else-if="language === 'fr'">
                            {{download.nameFr}}
                        </template>
                        <template v-else>
                            {{download.nameEn}}
                        </template>
                    </div>
                    <div>
                        <a :href="download.pathNl" target="_blank" v-if="download.hasFileNl" :download="integration.name+'_'+download.nameNl+'.pdf'" class="btn btn-primary btn-sm"><i class="fas fa-download mr-2"></i>NL</a>
                    </div>
                    <div>
                        <a :href="download.pathFr" target="_blank" v-if="download.hasFileFr" :download="integration.name+'_'+download.nameFr+'.pdf'" class="btn btn-primary btn-sm"><i class="fas fa-download mr-2"></i>FR</a>
                    </div>
                    <div>
                        <a :href="download.pathEn" target="_blank" v-if="download.hasFileEn" :download="integration.name+'_'+download.nameEn+'.pdf'" class="btn btn-primary btn-sm"><i class="fas fa-download mr-2"></i>EN</a>
                    </div>
                </div>
            </div>
        </div>
        <coming-soon v-else-if="integration.label === SoftwareLabel.COMINGSOON" :integration="integration" :isLoggedInWithEmail="isLoggedIn && hasEmail" :language="language"></coming-soon>
        <no-account v-else-if="!isLoggedIn" :integratorId="integration.integratorCredentials.softwareId" :language="language"></no-account>
        <institute v-else-if="isInstitute" :integration="integration" :language="language"></institute>
        <not-activatable v-else-if="integration.ctaType === CtaType.CONTACTUS && !isActivated" :integration="integration" :language="language"></not-activatable>
        <div class="border rounded-xl shadow-sm border-grey-200 p-10 bg-grey-100/60" v-else-if="integration.ctaType === CtaType.ACTIVATABLE">
           <h2 class="font-medium">{{translate('aan_de_slag')}}</h2>
            
            <div v-if="intro" v-html="intro"></div>

            <template v-if="isLoading">
                <div class="text-center py-5">
                    <i class="fas fa-spinner animate-spin text-primary-400 fa-2x"></i>
                </div>
            </template>
            <template v-else>
                <p class="mt-6">
                    {{translate('activation_details')}}
                </p>
                <div class="mt-6">
                    <input id="IkGaAkkoord" type="checkbox" v-model="hasAcceptedTerms"/>
                    <label for="IkGaAkkoord">
                        <translation label="ik_ga_akkoord_met">
                            <a :href="termsLink" class="link">{{ translate('de_gebruiksvoorwaarden').toLowerCase() }}</a>
                        </translation>
                    </label>
                </div>
                <div class="mt-6">
                    <button class="btn btn-primary" @click.prevent="activate()" :disabled="!hasAcceptedTerms">{{translate('btn_activate')}}</button>
                </div>
            </template>
       </div>
    </div>
</template>

<script lang="ts">
    import { Language } from '../../types/dto/Language';
    import Ajax from '../../lib/Ajax';
    import NoAccount from './components/no-account.vue';
    import Institute from './components/institute.vue';
    import {defineComponent} from 'vue';
    import NotActivatable from './components/not-activatable.vue';
    import ComingSoon from './components/coming-soon.vue';
    import {SoftwarePartner, SoftwarePartnerManual, SoftwareLabel, CtaType} from '../../types/dto/SoftwarePartner';
    import { ApiUser } from '../../types/dto/ApiUser';
    import Translation from "../../components/translation.vue";
    
    type FakeApiUser = Omit<ApiUser, "software"|"customerId"|"id"|"customerName">
    
    export default defineComponent({
        name: 'integration-detail',
        components: {Translation, NoAccount, Institute, NotActivatable, ComingSoon },
        data() {
            return {
                integration: window.cw.integration as SoftwarePartner,
                language: window.cw.language as Language,
                hasAcceptedTerms: false as boolean,
                isActivated: false as Boolean,
                apiCredentials: null as ApiUser | FakeApiUser | null,
                isLoading: false,
                downloads: [] as SoftwarePartnerManual[],
                isLoggedIn: window.cw.isLoggedIn,
                hasEmail: window.cw.hasEmail,
                isAdmin: window.cw.isAdmin,
                isInstitute: window.cw.isInstitute,
                isTrial: window.cw.isTrial,
                termsLink: window.cw.termsLink,
                isSalesUser: window.cw.isSalesUser,
                SoftwareLabel,
                CtaType
            };
        },
        computed: {
            canSeeCredentials(): boolean {
                const isForeverActive = !this.apiCredentials?.endDate; 

                return !isForeverActive || this.isAdmin;
            },
            apiStepNumber(): number {
                return this.hasInstallStep ? 2 : 1;
            },
            downloadsStepNumber(): number {
                return this.hasInstallStep ? 3 : 2;
            },
            hasInstallStep(): boolean {
                return !!this.externalLinkText || !!this.appText;
            },
            intro(): string | null {
                switch(this.language){
                    case Language.NL:
                        return this.integration.introNl;
                    case Language.FR:
                        return this.integration.introFr;
                    case Language.EN:
                        return this.integration.introEn;
                    default:
                        return this.integration.introNl;
                }
            },
            externalLinkText(): string | null {
                 switch(this.language){
                    case Language.NL:
                        return this.integration.externalLinkTextNl;
                    case Language.FR:
                        return this.integration.externalLinkTextFr;
                    case Language.EN:
                        return this.integration.externalLinkTextEn;
                    default:
                        return this.integration.externalLinkTextNl;
                }
            },
            partnerText(): string | null {
                 switch(this.language){
                    case Language.NL:
                        return this.integration.partnerTextNl;
                    case Language.FR:
                        return this.integration.partnerTextFr;
                    case Language.EN:
                        return this.integration.partnerTextEn;
                    default:
                        return this.integration.partnerTextNl;
                }
            },
            appText(): string | null {
                switch(this.language){
                    case Language.NL:
                        return this.integration.appTextNl;
                    case Language.FR:
                        return this.integration.appTextFr;
                    case Language.EN:
                        return this.integration.appTextEn;
                    default:
                        return this.integration.appTextNl;
                }
            }
        },
        methods: {
            async ajaxActivate(): Promise<ApiUser | FakeApiUser> {
                return new Promise((resolve, reject) => {
                    if(this.isSalesUser) {
                        const fakeCredentials: FakeApiUser = {
                            login: "ABCDEF-XXX-OOO",
                            password: "D2F2G8",
                            creationDate: new Date().toHansDate(),
                            endDate: new Date(Date.now() + 12096e5).toHansDate()                            
                        };

                        this.isActivated = true;
                        resolve(fakeCredentials);
                    } else {
                        this.isLoading = true;
                        Ajax.post(
                            "/ajax/integrations/activate",
                        {
                            softwareId: this.integration.id
                        },
                        (response: AjaxResponse<ApiUser>) => {
                            this.isLoading = false;
                            this.isActivated = true;
                            resolve(response.data);
                        },
                        error => {
                            this.isLoading = false;
                            reject(error);
                        });
                    }
                });
            },
            async activate(): Promise<void> {
                this.apiCredentials = await this.ajaxActivate();
                this.getDownloads();
            },
            checkIfActivated(): void {
                this.isLoading = true;
                  Ajax.get(
                    "/ajax/integrations/has-integration",
                    {
                        softwareId: this.integration.id
                    },
                    (response: AjaxResponse<boolean>) => {
                        this.isLoading = false;
                        this.isActivated = response.data;

                        if (this.isActivated) {
                            this.getApiUser();
                            this.getDownloads();
                        }
                    },
                    error => {
                        this.isLoading = false;
                        console.error(error);
                    }
                )
            },
            getApiUser(): void {
                this.isLoading = true;
                  Ajax.get(
                    "/ajax/integrations/api-user",
                    {
                        softwareId: this.integration.id
                    },
                    (response: AjaxResponse<ApiUser>) => {
                        this.isLoading = false;
                        this.apiCredentials = response.data;
                    },
                    error => {
                        this.isLoading = false;
                        console.error(error);
                    }
                )
            },
            getDownloads(): void {
                  this.isLoading = true;
                  Ajax.get(
                    "/ajax/integrations/manuals",
                    {
                        softwareId: this.integration.id
                    },
                    (response: AjaxResponse<SoftwarePartnerManual[]>) => {
                        this.isLoading = false;
                        this.downloads = response.data;
                    },
                    error => {
                        this.isLoading = false;
                        console.error(error);
                    }
                )
            }
        },
        created() {
            if(this.isLoggedIn && !this.isInstitute)
                this.checkIfActivated();
        }
    });
</script>
